const getters = {
    getMe: (state) => (id) =>  {
        //console.log("getMe state : ", state.userInfo.id, "\tid :", id )
        if(state.userInfo.id == id)return true;
        return false;
    }
}
export default getters